import { AdsGenerator } from '@/components/Ads/Google/AdsTypeGeneratorsMemo';
import Icon from '@/components/Layout/Icon';
import { AdContainer } from '@/components/Layout/ItemListLastNews/styles';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useState } from 'react';

export default function CustomSearch({ query }: { query?: string }) {
  const [keyword, setKeyword] = useState(query || '');
  const router = useRouter();

  const isValid = () => keyword.trim().length > 0 && keyword !== router.query.q;
  return (
    <>
      <header className="bg-mglGray900 p-10 tablet:px-20">
        <div className="m-auto px-4 py-0">
          <div className="mx-[-0.625rem] my-0 flex flex-[0] flex-row flex-wrap">
            <div className="max-w-full basis-full">
              <form
                onSubmit={event => {
                  if (!isValid()) event.preventDefault();
                }}>
                <div className="relative w-full">
                  <label className="absolute m-[-1px] h-[1px] w-[1px] overflow-hidden border-0 p-0 [clip:rect(0,0,0,0)]" htmlFor="pesquisa">
                    Busca
                  </label>
                  <input
                    className="mb-0 min-h-[50px] w-full border-0 border-b border-solid border-b-mglGray50 bg-mglGray900 text-4xl text-mglGray50 transition-[border-bottom-color] duration-300 ease-ease focus:border-b-mglGray600 [&::-webkit-search-cancel-button]:hidden"
                    id="pesquisa"
                    type="search"
                    aria-label="Buscar no site"
                    placeholder="Buscar"
                    name="q"
                    value={keyword}
                    onChange={event => setKeyword(event.target.value)}
                  />
                  <button
                    className="absolute right-0 top-0 z-[5] m-0 cursor-pointer appearance-none rounded border-0 bg-transparent p-0 text-4xl uppercase leading-10 text-mglGray50 shadow-none outline-none transition-colors duration-300 ease-ease"
                    type="submit"
                    aria-label="Botão pesquisar">
                    <Icon icon="mdi:magnify" />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </header>
      <div className="p-0 tablet:[&>div]:p-[initial]">
        <AdContainer billboard>
          <AdsGenerator type="billboard" />
        </AdContainer>
      </div>
      <section className="custom-search">
        <div className="m-auto bg-mglGray50 px-4 py-0">
          <div className="mx-[-0.625rem] my-0 flex flex-[0] flex-row flex-wrap">
            <div className="max-w-full basis-full" id="g-results">
              <Script async src="https://cse.google.com/cse.js?cx=004659546419109346008:o_5stijrvfi" />
              <div className="gcse-searchresults-only" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
